import React, { PureComponent, Fragment } from 'react';
import { NavLink } from 'react-router-dom';

import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';

import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import { isFutureDate, stableSort, getSorting, insertIf } from '../Common/helpers';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';
import moment from 'moment';

import './style.css';

function appointmentEnd(appointment) {
    return appointment.AppointmentEnd ? appointment.AppointmentEnd.slice(0, 5)
        : moment(appointment.AppointmentStart || appointment.HoursAppointment, 'HH:mm:ss')
            .add(Number(appointment.DurationMinutes || 30), 'minutes').format('HH:mm');
}

function appointmentInterval(appointment) {
    return (appointment.AppointmentStart || appointment.HoursAppointment).slice(0, 5) + '–' + appointmentEnd(appointment);
}

export function groupAppointmentHours(appointments) {
    const groups = {};
    (Array.isArray(appointments) ? appointments : []).forEach(appointment => {
        const hour = appointment.HoursAppointment.slice(0, 2) + ':00';
        if (!groups[hour]) groups[hour] = {hour, slots: []};
        groups[hour].slots.push(appointment);
    });
    return Object.values(groups).sort((a, b) => a.hour.localeCompare(b.hour)).map(group => ({
        ...group,
        slots: group.slots.sort((a, b) => a.HoursAppointment.localeCompare(b.HoursAppointment)),
        occupied: group.slots.some(slot => !!slot.Id),
        available: group.slots.filter(slot => !slot.Id && slot.IsWorking === '1').length,
        bookings: group.slots.filter(slot => !!slot.Id && !slot.IsContinuation),
        continuation: group.slots.some(slot => !!slot.Id && slot.IsContinuation),
    }));
}

class AppointmentsTable extends PureComponent {
    state = {
        order:'asc'
        , orderBy:'HoursAppointment'
        , page:0
        , openModal:false
        , expandedHours:{}
    };

    tableHeadClone = React.createRef();
    tableHeadRef = React.createRef();

    componentDidUpdate(previousProps){
        if (previousProps.selectedDate !== this.props.selectedDate || previousProps.staffId !== this.props.staffId) {
            this.setState({expandedHours: {}, page: 0});
        }
    }

    isHourExpanded = group => Object.prototype.hasOwnProperty.call(this.state.expandedHours, group.hour)
        ? this.state.expandedHours[group.hour] : group.occupied;

    toggleHour = group => this.setState(previous => ({
        expandedHours: {...previous.expandedHours, [group.hour]: !(Object.prototype.hasOwnProperty.call(previous.expandedHours, group.hour)
            ? previous.expandedHours[group.hour] : group.occupied)}
    }));

    setAllHours = expanded => this.setState({expandedHours:
        groupAppointmentHours(this.props.fetchData || []).reduce((hours, group) => ({...hours, [group.hour]: expanded}), {})
    });

    deleteRow = (appointmentId) => {
        if(window.confirm("Tem a certeza que quer apagar esta marcação?")){
            this.setState({loading:true});
            fetch(API + 'deleteappointment&appointmentid=' + appointmentId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
            });
        }
    }

    toggleConfirmedAppointment = (e) => {
        const el = document.getElementById(e.target.id);
        
        if(e.target.checked){
            fetch(API + "setconfirmedappointment&appointmentid=" + e.target.dataset.appid + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                if(result !== null && result.shortmsg === "OK")
                el.closest(".tableRow").classList.add("successBorder");
            });
        }else{
            fetch(API + "unsetconfirmedappointment&appointmentid=" + e.target.dataset.appid + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                if(result !== null && result.shortmsg === "OK")
                el.closest(".tableRow").classList.remove("successBorder");
            });
        }
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.reloadTable(null);
        //window.location.reload();
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.props.handleChangeRowsPerPage(event.target.value);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy, page: 0 });
    };

    renderAppointmentRow = (appointment, index) => {
        const { isAdmin, loginData, staffName } = this.props;
        const appointmentDate = this.props.selectedDate;
        return (
<TableRow key={appointment.Id + "_" + index} className={"tableRow" + (appointment.Confirmed === "1" ? " successBorder" : "")} ref={"appointmentId_" + appointment.Id}>
                            <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: appointment.StoreColor}}></div> {appointment.StoreShortname}</TableCell>
                            <TableCell data-title="Horas" className="tableCell">{appointment.Id && !appointment.IsContinuation ? appointmentInterval(appointment) : appointment.HoursAppointment.slice(0, 5)}</TableCell>
                            <TableCell data-title="Cliente" className="tableCell">
                                {appointment.ClientId &&
                                    <Tooltip
                                        title={appointment.CId + " - " + appointment.ClientFirstName + " " + appointment.ClientLastName + " (" + appointment.ClientCellPhone + ")"}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Clients/"+appointment.ClientId}>{appointment.ClientFirstName} {appointment.ClientLastName}</NavLink></span>
                                    </Tooltip>
                                }
                                {
                                    appointment.ClientId && appointment.ClientGlobalNotes && loginData.profile.Clients && loginData.profile.Clients.globalNotes &&
                                    <Tooltip
                                        title={appointment.ClientGlobalNotes}
                                        enterDelay={200}>
                                        <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: appointment.ClientGlobalNotes })}><i className="far fa-sticky-note fa-2x"></i></button></span>
                                    </Tooltip>
                                }
                            </TableCell>
                            {   !staffName &&
                                <TableCell data-title="Funcionário" className="tableCell">
                                    <Tooltip
                                        title={appointment.SId+" - "+appointment.StaffFirstName+" "+appointment.StaffLastName}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Staff/"+appointment.StaffId}>{appointment.StaffFirstName} {appointment.StaffLastName}</NavLink></span>
                                    </Tooltip>
                                </TableCell>
                            }
                            <TableCell data-title="Tratamento" className="tableCell">{appointment.Treatment}</TableCell>
                            <TableCell data-title="Ações" className="tableCell actions actionsBig" data-row-id={appointment.Id}>
                                {appointment.IsContinuation ? <span>Reservado até às {appointmentEnd(appointment)}</span> : appointment.ClientId ?
                                    (isAdmin || loginData.profile.Appointments.permission === 1) && isFutureDate(new Date(appointment.DateAppointment + " " + appointment.HoursAppointment)) ?    
                                        <span>                                
                                            <Tooltip
                                                title={"Confirmar marcação"}
                                                enterDelay={200}>
                                                <span><input type="checkbox" id={"confirm_" + appointment.Id} onChange={this.toggleConfirmedAppointment} data-appid={appointment.Id} defaultChecked={appointment.Confirmed === "1" ? true : false} /></span>
                                            </Tooltip>                     
                                            <Tooltip
                                                title={"Editar marcação"}
                                                enterDelay={200}>
                                                <span><NavLink className="actionButton warning" to={{pathname:"/Appointments/"+appointment.Id, storeId:appointment.StoreId, staffId:this.props.staffId}}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                            </Tooltip>
                                        </span>
                                        :                                  
                                        <Tooltip
                                            title={"Ver marcação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={{pathname:"/Appointments/"+appointment.Id, blockDates:true, storeId:appointment.StoreId, staffId:this.props.staffId, appDate:appointmentDate, appHour:appointment.HoursAppointment.slice(0, -3)}}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    :
                                    (isAdmin || loginData.profile.Appointments.ADD) && appointment.IsWorking==="1" && isFutureDate(new Date(appointmentDate + " " + appointment.HoursAppointment)) &&                                  
                                        <Tooltip
                                            title={"Adicionar marcação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={{pathname:"/Appointments/New", blockDates:true, storeId:appointment.StoreId, staffId:this.props.staffId, appDate:appointmentDate, appHour:appointment.HoursAppointment}}><i className="fa fa-plus"></i></NavLink></span>
                                        </Tooltip>
                                }
                                {!appointment.IsContinuation && (isAdmin || loginData.profile.Appointments.DEL) && appointment.ClientId &&
                                    <Tooltip
                                        title={"Eliminar marcação"}
                                        enterDelay={200}>
                                        <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(appointment.Id)}><i className="fa fa-times"></i></button></span>
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
        );
    };

    render() {
        const { staffName } = this.props;
        const appointments = Array.isArray(this.props.fetchData) ? this.props.fetchData : []
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , { order, orderBy, page } = this.state
              , rowsPerPage = this.props.rowsPerPage
              , headerRows = [
                  { id: 'StoreName', active: true, numeric: false, label: 'Loja' },
                  { id: 'HoursAppointment', numeric: false, label: 'Horas' },
                  { id: 'ClientFullName', numeric: false, label: 'Cliente' },
                  ...insertIf(!staffName, { id: 'StaffFullName', numeric: false, label: 'Funcionário' }),
                  { id: 'Treatment', numeric: false, label: 'Tratamento' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        const grouped = !!staffName;
        const groups = grouped ? groupAppointmentHours(appointments) : [];
        if (grouped && order === 'desc') groups.reverse();
        const count = grouped ? groups.length : appointments.length;
        const currentPage = Math.min(page, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        const visibleGroups = groups.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);
        const visibleAppointments = grouped ? [] : stableSort(appointments, getSorting(order, orderBy))
            .slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);

        return (
            <div className="tableHolder">
                <Table className={"responsiveTable customTable originalTable" + loadingClass}>
                    <TableHead ref={this.tableHeadRef}>
                        <TableRow className="tableRow tableHeader">
                            <TableCell className="tableCell" colSpan="6"><h2 className="bigHeading">Marcações para {staffName}{this.props.dateName}</h2>{grouped && <div className="appointment-hour-controls">
                    <button type="button" className="simpleBtn" onClick={() => this.setAllHours(true)}>Expandir tudo</button>
                    <button type="button" className="simpleBtn" onClick={() => this.setAllHours(false)}>Recolher tudo</button>
                </div>}</TableCell>
                        </TableRow>
                    </TableHead>
                    <EnhancedTableHead
                        className="tableRow tableHeader"
                        headerRows={grouped ? headerRows.map(row => ({...row, notSortable: row.id !== 'HoursAppointment'})) : headerRows}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={this.handleRequestSort}
                        rowCount={appointments.length}>
                    </EnhancedTableHead>
                    <TableBody>
                        {grouped ? visibleGroups.map(group => <Fragment key={group.hour}>
                            <TableRow className="appointment-hour-row">
                                <TableCell colSpan={headerRows.length}>
                                    <button type="button" className="appointment-hour-toggle" aria-expanded={this.isHourExpanded(group)}
                                        aria-label={(this.isHourExpanded(group) ? 'Recolher ' : 'Expandir ') + group.hour}
                                        onClick={() => this.toggleHour(group)}>
                                        <i aria-hidden="true" className={'fa fa-chevron-' + (this.isHourExpanded(group) ? 'up' : 'down')} />
                                        <strong>{group.hour}</strong>
                                        <span className="appointment-hour-summary">
                                            {group.bookings.length ? group.bookings.length + (group.bookings.length === 1 ? ' marcação' : ' marcações')
                                                : group.continuation ? 'Reservado até às ' + appointmentEnd(group.slots.find(slot => slot.Id && slot.IsContinuation)) : 'Sem marcações'}
                                            {' · '}{group.available ? group.available + (group.available === 1 ? ' início disponível' : ' inícios disponíveis') : 'Sem horários disponíveis'}
                                            {group.bookings.length > 0 && <span className="appointment-hour-bookings">
                                                {group.bookings.map(slot => appointmentInterval(slot) + ' ' + (slot.ClientFirstName || '') + ' ' + (slot.ClientLastName || '') + (slot.Treatment ? ' (' + slot.Treatment + ')' : '')).join(' | ')}
                                            </span>}
                                        </span>
                                    </button>
                                </TableCell>
                            </TableRow>
                            {this.isHourExpanded(group) && group.slots.map((appointment, index) => this.renderAppointmentRow(appointment, index))}
                        </Fragment>) : visibleAppointments.map((appointment, index) => this.renderAppointmentRow(appointment, index))}
                    </TableBody>
                </Table>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[15, 30]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage={grouped ? 'Horas por página:' : 'Linhas por página:'}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={currentPage}
                            backIconButtonProps={{'aria-label': 'Página anterior',}}
                            nextIconButtonProps={{'aria-label': 'Próxima página'}}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AppointmentsTable;
